import React from 'react';
import XMLViewer from 'react-xml-viewer'

const xml = '<hello>Загрузка XML</hello>'
const xml_url = 'http://csi.hbz.local/_data/stamm.wsdl.xml'

//Компонента отображения содержимого WSDL
// на базе http://tomi.vanek.sk/

const options = {
    method: 'POST',
    credentials: 'include',
    mode: 'cors'
  }

class WSDLViewer extends React.Component {
  
    constructor(props, context) {
        super(props, context)
        this.state = {
            asXmlView: false,             //Как XML
            data: undefined
        }
        this.onChangeView = this.onChangeView.bind(this);        
    }
    
    componentDidMount () {
        this.fetchData();
      }
    fetchData() {
        fetch(xml_url, options)
          .then((response) => response.text())
          .then(response => {
            this.setState({
              data: response,
            });
          })
    }
    
    //Событие об изменения формы отображения выбранной версии ЕМД
    onChangeView(e) {
        const {asXmlView} = this.state
        this.setState({asXmlView: !asXmlView});
    }

    render() {
        const {asXmlView, data} = this.state
        const value = (data==undefined)? xml:data;
        console.log(this);
        return (
            (asXmlView? 
                <div>
                    <div onClick={()=> this.onChangeView()} >Полная форма</div>
                    <XMLViewer xml={value} />
                </div>
               :
                <div>
                    <div onClick={()=> this.onChangeView()} >Краткая форма</div>
                    <iframe src="http://csi.hbz.local/_data/stamm.wsdl.xml" width="100%" height="450"></iframe>
                </div>
           ) 
        )
    }
}

export default WSDLViewer;